/**
 * RoSeal - Augmented Roblox Experience — Roblox site enhancer
 *
 * Declares one WAR group (css/*, fonts/*, img/* and html/popup.html) with no
 * use_dynamic_url, but scoped to the Roblox origins only — www.roblox.com and
 * create.roblox.com. The resources are static and served from fixed URLs, so they are
 * reachable, but only from a Roblox page. From any other origin the match fails and a
 * negative result proves nothing, so this is a scoped detector keyed to www.roblox.com.
 *
 * Manifest verified against version 2.1.59.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'hfjngafpndganmdggnapblamgbfjhnof';

export const roseal: ExtensionDefinition = {
  id: ID,
  name: 'RoSeal - Augmented Roblox Experience',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  requiredOrigin: 'https://www.roblox.com',
  notes:
    'Static WAR (css, fonts, img, popup.html) scoped to the Roblox origins, no dynamic ' +
    'URL. Only a Roblox page can reach them, so detection is conclusive there and ' +
    'inconclusive elsewhere.',
  signals: [
    {
      id: 'war-popup-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch html/popup.html — the popup UI, static but only exposed to the Roblox origins.',
      weight: 1,
      run: () => probeFetch(ID, 'html/popup.html'),
    },
    {
      id: 'war-all-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch css/all.css — a vendor stylesheet, the second origin-scoped static resource.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/all.css'),
    },
    {
      id: 'war-icon-128-png',
      kind: 'web-accessible-resource',
      description:
        'Fetch img/icon/128.png — a third origin-scoped static path, independent of the ' +
        'popup and stylesheet.',
      weight: 0.5,
      run: () => probeFetch(ID, 'img/icon/128.png'),
    },
  ],
};
